<template>
  <div
    class="wrap-error-page container-lg bg-white shadow-sm mt-5 mt-md-8 mb-10 d-flex flex-column align-items-center p-8"
  >
    <h3 class="mb-8">{{ $t('網頁出錯了') }}</h3>
    <span class="text-center"
      >{{ $t('找不到頁面的資料') }}，<br />{{
        $t('您可以嘗試重新整理，或者返回首頁')
      }}！</span
    >
    <b-button
      variant="secondary"
      pill
      class="mt-8 btn-go-home font-weight-bold"
      @click="goHome"
      >{{ $t('返回首頁') }}</b-button
    >
  </div>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$store.commit('env/setIsNotFound', false);
      this.$router.push('/');
    },
  },
};
</script>
<style lang="scss">
.wrap-error-page {
  flex-grow: 1;
}
.btn-go-home {
  width: 160px;
}
</style>
